import { compose } from 'redux'
import { connect } from 'react-redux'
import withState from '../../withState'
import { withStyles } from '@material-ui/core/styles'
import { mapStateToProps } from './selector'
import { Radio } from './container'
import style from './style'

export default compose(
    connect(mapStateToProps),
    withStyles(style),
    withState()
)(Radio)